import { RESET_PASSWORD_VERIFY_ACCOUNT_CLEAR } from './constants';

export function clearVerifyAccount() {
  return (dispatch) => {
    dispatch({
      type: RESET_PASSWORD_VERIFY_ACCOUNT_CLEAR,
    })
  }
}

export function reducer(state, action) {
  if (action.type === RESET_PASSWORD_VERIFY_ACCOUNT_CLEAR) {
      return {
        ...state,
        verifyAccountSuccess: false,
        verifyAccountPending: false,
        verifyAccountError: false,
      }
  }
  else {
    return state
 }
}